import { spreadByBreakpoints } from './media-spread';
import { sizes } from '../breakpoints';
export const combineByBreakpoints = (props, modifyFn) => {
  const values = props.map(value => spreadByBreakpoints(value, true));
  return sizes.reduce((acc, size) => ({
    ...acc,
    [size]: modifyFn(values.map(value => value[size]))
  }), {});
};